import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Mail, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/brand";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Não foi possível entrar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-choco flex items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md bg-cream rounded-3xl p-8 sm:p-10 shadow-2xl">
        <div className="text-center mb-8">
          <img src={BRAND.logo} alt="Deco Sweet" className="h-20 w-auto object-contain mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-choco">Painel Administrativo</h1>
          <p className="text-sm text-muted-foreground mt-1">Acesse para gerenciar seus produtos.</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-choco/70">E-mail</label>
            <div className="relative mt-2">
              <Mail size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
                className="w-full rounded-xl border border-choco/15 bg-white pl-11 pr-4 py-3.5 text-sm text-choco focus:outline-none focus:border-gold transition-colors" placeholder="seu@email.com" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-choco/70">Senha</label>
            <div className="relative mt-2">
              <Lock size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
                className="w-full rounded-xl border border-choco/15 bg-white pl-11 pr-4 py-3.5 text-sm text-choco focus:outline-none focus:border-gold transition-colors" placeholder="••••••••" />
            </div>
          </div>

          {error && <p className="text-sm text-red-700 bg-red-50 rounded-lg px-4 py-2" data-testid="admin-error">{error}</p>}

          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full rounded-xl bg-choco text-cream py-3.5 text-sm font-semibold uppercase tracking-widest hover:bg-gold transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 size={17} className="animate-spin" />} Entrar
          </button>
        </form>
        <a href="/" className="block text-center text-xs text-muted-foreground mt-6 hover:text-choco transition-colors">← Voltar ao site</a>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
